import { PropertyMetaData } from './property-meta-data';
import { PositionMetaDataInterface } from './position-meta-data.interface';
import { NumericMetaData } from './numeric-meta-data';
import { StringMetaData } from './string-meta-data';
import { BoolMetaData } from './bool-meta-data';
import { DateTimeMetaData } from './date-time-meta-data';
import { EnumMetaData } from './enum-meta-data';
import { InternalRelationMetaData } from './internal-relation-meta-data';
import { ExternalMetaData, InternalCollectionMetaData } from './domain-model-meta-data';
import { Expose, Type } from '@nts/std/serialization';
import { GuidMetaData } from './guid-meta-data';
import { OrderByType } from '@nts/std/types';
import type { BoolMetaDataInterface, DateTimeMetaDataInterface, EnumMetaDataInterface, GuidMetaDataInterface, InternalCollectionMetaDataInterface, InternalRelationMetaDataInterface, NumericMetaDataInterface, PropertyMetaDataInterface, StringMetaDataInterface } from '@nts/std/interfaces';

export class ZoomMetaData implements PositionMetaDataInterface {

    position: number;
    isVisible?: boolean;
    orderBy?: OrderByType;
    orderByIndex?: number;
    isRootIdentity: boolean;
    isIdentity: boolean;

    @Expose()
    @Type(() => PropertyMetaData)
    propertyMetadata: PropertyMetaDataInterface;

    @Expose()
    @Type(() => InternalRelationMetaData)
    internalRelation: InternalRelationMetaDataInterface;

    @Expose()
    @Type(() => ExternalMetaData)
    external: ExternalMetaData;

    @Expose()
    @Type(() => InternalCollectionMetaData)
    internalCollection: InternalCollectionMetaDataInterface;

    @Expose()
    displayName: string;

    @Expose()
    get propertyPath(): string {
        if (this.propertyMetadata) {
            const property = this.propertyMetadata?.name;
            return this.rootPath ? this.rootPath + '.' + property : property;
        } else {
            return '';
        }
    }

    @Expose()
    @Type(() => ZoomMetaData)
    parent: ZoomMetaData;

    @Expose()
    rootPath: string;

    @Expose()
    @Type(() => NumericMetaData)
    numericMetaData: NumericMetaDataInterface;

    @Expose()
    @Type(() => StringMetaData)
    stringMetaData: StringMetaDataInterface;

    @Expose()
    @Type(() => GuidMetaData)
    guidMetaData: GuidMetaDataInterface;

    @Expose()
    @Type(() => BoolMetaData)
    booleanMetaData: BoolMetaDataInterface;

    @Expose()
    @Type(() => DateTimeMetaData)
    dateTimeMetaData: DateTimeMetaDataInterface;

    @Expose()
    @Type(() => EnumMetaData)
    enumMetaData: EnumMetaDataInterface;

    @Expose()
    level: number;

}
